import React from 'react';

const ValueOrInfinity = ({value}) => <span>{value || '∞'}</span>;

export default ValueOrInfinity;
